/**
 * 权限定义文件
 *
 * 基于 Umi Max Access 插件，定义权限检查函数。
 * 使用 Action_Permission 模型（menu_id + group + code）进行细粒度权限控制。
 *
 * Requirements: 5.1, 5.3
 * @see https://umijs.org/docs/max/access#access
 */
import type { InitialState } from './app';

export default function access(initialState: InitialState | undefined) {
  const { currentUser, permissions = [], isRoot } = initialState ?? {};

  /**
   * 检查当前用户是否拥有指定的操作权限
   *
   * - 超级管理员（isRoot）直接返回 true
   * - 普通用户通过匹配 permissions 列表中的 menu_id + group + code 判断
   *
   * @param menuId - 菜单 ID
   * @param group - 权限分组
   * @param code - 权限代码
   * @returns 是否拥有该权限
   */
  const hasPermission = (
    menuId: string,
    group: string,
    code: string,
  ): boolean => {
    if (isRoot) return true;
    return permissions.some(
      (p) => p.menu_id === menuId && p.group === group && p.code === code,
    );
  };

  return {
    /** 用户是否已登录 */
    isLoggedIn: !!currentUser,
    /** 用户是否为超级管理员 */
    isRoot: !!isRoot,
    /** 操作级权限检查函数 */
    hasPermission,
  };
}
